import { render, staticRenderFns } from "./FrsCultivationOverviewTable.vue?vue&type=template&id=21f1e008&scoped=true&"
import script from "./FrsCultivationOverviewTable.vue?vue&type=script&lang=js&"
export * from "./FrsCultivationOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./FrsCultivationOverviewTable.vue?vue&type=style&index=0&id=21f1e008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1e008",
  null
  
)

export default component.exports